import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import UserRecord from '../../../records/user';
import { formatPhone, toTitleCase } from '../../../constants/helpers';
import { useCreateAccount } from '../../../hooks/useAccount';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
  
const cancelIcon = <FontAwesomeIcon icon={faXmark} />
const checkIcon = <FontAwesomeIcon icon={faCheck} />

export default function Add() {
  const [cashier, setCashier] = useState(new UserRecord({
    role: 'staff'
  }));
  const [errors, setErrors] = useState([]);

  const navigate = useNavigate();
  const create = useCreateAccount();

  const save = () => {
    if (cashier.first_name === '') setErrors(errors.push('first_name'));
    if (cashier.last_name === '') setErrors(errors.push('last_name'));
    if (cashier.email === '') setErrors(errors.push('email'));

    const normalized = cashier
      .set('first_name', toTitleCase(cashier.first_name))
      .set('last_name', toTitleCase(cashier.last_name))
      .set('email', cashier.email.toLowerCase().trim());

    create.mutateAsync(normalized)
      .then(() => navigate('/admin/cashiers'));
  }

  return (
    <div>
      <div className="title">Add Cashier</div>
      <div className="field">
        <label className="label">First Name <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" 
            type="text" 
            name="first_name" 
            onChange={e => setCashier(cashier.set('first_name', e.target.value))} 
            value={cashier.first_name} 
          />
          {errors.first_name && <div className="has-text-danger has-text-weight-semibold">{errors.first_name}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Last Name <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" 
            type="text" 
            name="last_name" 
            onChange={e => setCashier(cashier.set('last_name', e.target.value))} 
            value={cashier.last_name} 
          />
          {errors.last_name && <div className="has-text-danger has-text-weight-semibold">{errors.last_name}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Email <span style={{ color: 'red' }}>*</span></label>
        <div className="control">
          <input className="input" 
            type="text" 
            name="email" 
            onChange={e => setCashier(cashier.set('email', e.target.value))} 
            value={cashier.email} 
          />
          {errors.email && <div className="has-text-danger has-text-weight-semibold">{errors.email}</div>}
        </div>
      </div>

      <div className="field">
        <label className="label">Phone</label>
        <div className="control">
          <input
            className="input"
            type="text"
            name="phone"
            mask="(999) 999-9999"
            onChange={e => setCashier(cashier.set('phone', e.target.value))} 
            value={formatPhone(cashier.phone)}
          />
          {errors.phone && <div className="has-text-danger has-text-weight-semibold">{errors.phone}</div>}
        </div>
      </div>

      <div className="buttons is-grouped">
        <button className="button is-link" onClick={save} disabled={create.isLoading}>
          <span className="icon">
            <i>{checkIcon}</i>
          </span>
          <span>Save</span>
        </button>
        <button className="button is-info" onClick={() => navigate('/admin/cashiers')}>
          <span className="icon">
            <i>{cancelIcon}</i>
          </span>
          <span>Cancel</span>
        </button>
      </div>
    </div>
  )
}
